
export const REQUEST_BASE_URL = '//m.gm99.com/ajax/'

export const GET_GAME_INFO = 'getGameInfo'
export const GET_ARTICLE_LIST = 'getArticleList'
export const GET_ARTICLE_DETAIL = 'getArticleDetail'
export const GET_SLIDE_LIST = 'getSlideList'

export const SET_GAME_INFO = 'setGameInfo'
export const SET_DEVICE_TYPE = 'setDeviceType'
export const SET_NAV_ARTICLE_TYPE = 'setNavArticleType'

export const GAME_ID = 39
export const ARTICLE_TYPE = {
  all: '216,217,218',
  news: '216',
  notices: '218',
  gamewiki: '217'
}

// 测试id
// export const GAME_ID = 29
// export const ARTICLE_TYPE = {
//   all: '168,169,170',
//   news: '168',
//   notices: '169',
//   gamewiki: '170'
// }
